import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import { Chart, CategoryScale } from 'chart.js';
import { useRapportChartSeries } from '../../Api/queriesRapport';
import LoadingSpiner from '../components/LoadingSpiner';

Chart.register(CategoryScale);

/**
 * Graphique Commandes / Paiements — optimisation :
 * avant : useAllCommandes + useAllPaiements puis boucles JS sur toutes les lignes.
 * maintenant : GET /api/rapport/chart-series (agrégation $month sur createdAt, identique à l’ancien composant).
 */
const BarChartCommandePaiement = () => {
  const { data: series, isLoading, error } = useRapportChartSeries();

  const labels = [
    'Jan',
    'Fév',
    'Mar',
    'Avr',
    'Mai',
    'Jui',
    'Juil',
    'Aoû',
    'Sep',
    'Oct',
    'Nov',
    'Déc',
  ];

  const z = (arr) => (Array.isArray(arr) ? arr : new Array(12).fill(0));

  const data = {
    labels,
    datasets: [
      {
        label: 'Nombre de Commandes',
        data: z(series?.commandesCountByMonth),
        backgroundColor: ' #5F8B4C',
        barThickness: 10,
      },
      {
        label: `Somme à Payé  `,
        data: z(series?.paiementsTotalAmountByMonth),
        backgroundColor: ' #FFD63A',
        barThickness: 10,
      },

      {
        label: `Somme Payé`,
        data: z(series?.paiementsTotalPayeByMonth),
        backgroundColor: ' #4cd13a',
        barThickness: 10,
      },
      {
        label: `Somme Impayé`,
        data: z(series?.paiementsImpayeByMonth),
        backgroundColor: ' #d13a3a',
        barThickness: 10,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: '#102E50',
          boxWidth: 20,
          boxHeight: 20,
        },
      },
      title: {
        display: true,
        text: 'Statistiques de Boutique',
        color: '#102E50',
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
    hover: {
      mode: 'nearest',
      intersect: true,
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    layout: {
      padding: {
        top: 20,
        bottom: 20,
        left: 20,
        right: 20,
      },
    },
    animation: {
      duration: 1000,
      easing: 'easeInOutQuart',
    },
    animationSteps: 60,
    animationEasing: 'easeInOutQuart',
    responsiveAnimationDuration: 500,

    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: true,
        },
        ticks: {
          color: ' #102E50',
        },
      },
      y: {
        grid: {
          drawBorder: false,
        },
        ticks: {
          color: ' #3A59D1',
        },
        beginAtZero: true,
      },
    },
  };

  if (error) {
    return (
      <div className='text-danger text-center'>
        Erreur de chargement du graphique
      </div>
    );
  }

  return (
    <React.Fragment>
      {isLoading && <LoadingSpiner />}
      <Bar width={537} height={268} data={data} options={options} />
    </React.Fragment>
  );
};

export default BarChartCommandePaiement;
